import {Feature} from "../feature";
import type {GraphAtom} from "../graph/GraphAtom"
import {MolecularGraph} from "../graph/MolecularGraph"

export const atomCollector = {
    collectUsedAtoms: (features: Feature[]) => {
        const allUsedAtoms = features.reduce((acc, f) => acc.concat(...f.atoms), [] as GraphAtom[])
        return Array.from(new Set(allUsedAtoms)); // Filter dups
    },
    collectUnusedAtoms: (features: Feature[], graph: MolecularGraph) => {
        const used = atomCollector.collectUsedAtoms(features);
        return atomCollector.collectRemainingAtoms(used, graph);
    },
    collectRemainingAtoms: (used: GraphAtom[], graph: MolecularGraph) => {
        return graph.atoms.filter(a => !used.includes(a));
    }
}
